import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import { Form, Jumbotron, Row, Col } from "react-bootstrap";
import Button from "@edaz/edazkit/Button";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import LoginViewModel from "viewModels/loginViewModel";
import { IconType } from "@edaz/edazkit/Icon";
import { showMockFeature } from "../utils/featureToogle";
import AppHeader from "./appHeader";
import styles from "components/CzechPointBtn/czechPointBtn.module.scss";

const loginView: ViewComponent<LoginViewModel> = observer(({ vm }) => {
  return (
    <>
      <AppHeader vm={vm} />

      <div className="my-auto">
        <LoaderOverlay loading={vm.loginInProgress}>
          <Jumbotron style={{ maxWidth: 400 }} className="p-5 mb-3">
            <Row>
              <Col>
                <h3 className="mb-4">{vm.translateGeneral("login")}</h3>
              </Col>
            </Row>
            <Form>
              <Form.Group className="mt-4 mb-0">
                <Button
                  id="czechPointLogin"
                  className={styles.czechPointBtn}
                  onClick={vm.onCzechPointLogin}
                  block={true}
                  iconRight={IconType.ArrowRight}
                  iconRightAlign="left">
                  <span className="text-dark">Czech</span>
                  <span className="text-white">Point</span>
                </Button>
              </Form.Group>
              <Form.Group className="mt-4 mb-0">
                <Button
                  id="cendisLdapLogin"
                  onClick={vm.onCendisLdapLogin}
                  block={true}
                  variant="link"
                  className="text-primary link-underline"
                  iconRight={IconType.ArrowRight}
                  iconRightAlign="left">
                  {vm.translateGeneral("cendisLdapLogin")}
                </Button>
              </Form.Group>
              {showMockFeature && (
                <Form.Group className="mt-4 mb-0">
                  <Button
                    id="internalLogin"
                    onClick={vm.onInternalLogin}
                    block={true}
                    variant="primary"
                    iconRight={IconType.ArrowRight}
                    iconRightAlign="left">
                    {vm.translateGeneral("internalLogin")}
                  </Button>
                </Form.Group>
              )}
            </Form>
          </Jumbotron>
        </LoaderOverlay>
      </div>
    </>
  );
});

registerView(loginView, LoginViewModel);
